<re-process-failed-users title="Keycloak to IDM" (loaded)="load($event)">

</re-process-failed-users>
